import React, { useState, useEffect } from 'react';

// MUI Icons
import SearchIcon from '@mui/icons-material/Search';

const TextField = ({ 
    label = null, 
    name, 
    type, 
    value, 
    placeholder, 
    onChange, 
    error, 
    readOnly=false,
    required=false,
    className='',
    multiline=false
}) => {
    
    const [localValue, setLocalValue] = useState(value);

    const handleBlur = () => {
        if( onChange ){
            onChange({ target: { name, value: localValue } });
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onChange({ target: { name, value: localValue } });
        }
    };

    const handleChange = (e) => {
        if( onChange ){
            setLocalValue(e.target.value);
        }
    };

    useEffect(() => {
        if(localValue !== value) {
            setLocalValue(value);
        }
    }, [value]);

    return (
        <div className={`form-group ${error ? 'error' : ''} ${className}`}>
            {label &&
                <label htmlFor={name}>
                    {label}
                    {required && <span className='required'> *</span>}
                </label>
            }
            {'search' === type ? 
                <div className='search-input-container'>
                    <input 
                        type={type}
                        inputMode={'number' === type ? 'numeric' : 'text'}
                        name={name} 
                        value={localValue} 
                        onChange={handleChange} 
                        onBlur={handleBlur}
                        placeholder={placeholder}
                        readOnly={readOnly}
                        onKeyDown={handleKeyDown}
                    />
                    <span className='search-icon'><SearchIcon /></span>
                </div>
            : 
                <input 
                    type={type}
                    inputMode={'number' === type ? 'numeric' : 'text'}
                    name={name} 
                    value={localValue} 
                    onChange={handleChange} 
                    onBlur={handleBlur}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    onKeyDown={handleKeyDown}
                    multiline={multiline}
                />
            }
            {error ? <span className="error-message">{error}</span> : null}
        </div>
    );

}

export default TextField;